import ClutterImpactPage from '../../baseline/onboarding/ClutterImpactPage'
import CommitmentPage from '../../baseline/onboarding/CommitmentPage'
import CompletePage from '../../baseline/onboarding/CompletePage'
import FeelingPage from '../../baseline/onboarding/FeelingPage'
import FeelingsPage from '../../baseline/onboarding/FeelingsPage'
import GoalsFeedbackPage from '../../baseline/onboarding/GoalsFeedbackPage'
import GoalsPage from '../../baseline/onboarding/GoalsPage'
import LetGoPage from '../../baseline/onboarding/LetGoPage'
import NotAloneFeedbackPage from '../../baseline/onboarding/NotAloneFeedbackPage'
import ObstaclePage from '../../baseline/onboarding/ObstaclePage'
import OvercomeFeedbackPage from '../../baseline/onboarding/OvercomeFeedbackPage'
import PastAttemptsPage from '../../baseline/onboarding/PastAttemptsPage'
import RoomPage from '../../baseline/onboarding/RoomPage'
import StressLevelPage from '../../baseline/onboarding/StressLevelPage'
import StylePage from '../../baseline/onboarding/StylePage'
import SuggestionsPage from '../../baseline/onboarding/SuggestionsPage'
import SustainabilityPage from '../../baseline/onboarding/SustainabilityPage'
import UnsurePage from '../../baseline/onboarding/UnsurePage'
import VibePage from '../../baseline/onboarding/VibePage'

import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'
import { Outlet } from 'react-router-dom'

import CraftingProgressPage from './CraftingProgressPage'
import FutureVisualizationPage from './FutureVisualizationPage'
import IdentityShiftPage from './IdentityShiftPage'
import PersonalizedPlanPage from './PersonalizedPlanPage'

const onboardingRoutes = [
  {
    path: 'v1',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        action: navigateToNextOnboardingPageAction,
        element: <VibePage />,
        path: 'vibe',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ClutterImpactPage />,
        path: 'clutter-impact',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <GoalsPage />,
        path: 'goals',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <GoalsFeedbackPage />,
        path: 'goals-feedback',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <RoomPage />,
        path: 'room',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeelingsPage />,
        path: 'feelings',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <NotAloneFeedbackPage />,
        path: 'not-alone-feedback',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <StylePage />,
        path: 'style',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <UnsurePage />,
        path: 'unsure',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <PastAttemptsPage />,
        path: 'past-attempts',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ObstaclePage />,
        path: 'obstacle',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <OvercomeFeedbackPage />,
        path: 'overcome-feedback',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <LetGoPage />,
        path: 'letgo',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <StressLevelPage />,
        path: 'stress-level',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SustainabilityPage />,
        path: 'sustainability',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SuggestionsPage />,
        path: 'suggestions',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CommitmentPage />,
        path: 'commitment',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <IdentityShiftPage />,
        path: 'identity-shift',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FutureVisualizationPage />,
        path: 'future-visualization',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeelingPage />,
        path: 'feeling',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <PersonalizedPlanPage />,
        path: 'personalized-plan',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CraftingProgressPage />,
        path: 'crafting-progress',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CompletePage />,
        path: 'complete',
      },
    ],
  },
]

export default onboardingRoutes
